export default {"src":"__ASTRO_ASSET_IMAGE__BdP9cznX__","width":48,"height":48,"format":"svg"}